import Spinner from "src/javascripts/components/utilities/Spinner";
import ToastCustom from "src/javascripts/components/alerts/ToastCustom";
import Typeahead from "src/javascripts/components/Typeahead";
import {
  companiesBloodhound,
  fundsBloodhound,
  filterTypeahead,
  filterTypeaheadNoCache,
} from "src/javascripts/components/typeaheads/TypeaheadBloodhounds";
import {
  genericDisplayTemplate,
  logoTemplate,
  noResultsTemplate,
} from "src/javascripts/components/typeaheads/TypeaheadTemplates";

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require("src/javascripts/vendor/bloodhound");

function countFundsSelected() {
  return $("[id^='fund-selected-']").length;
}

function countCompaniesSelected() {
  return $("[id^='company-selected-']").length;
}

function countPortfoliosSelected() {
  return $("[id^='portfolio-selected-']").length;
}

function countListsSelected() {
  return $("[id^='list-selected-']").length;
}

function countCheckboxItems() {
  return (
    countFundsSelected() + countCompaniesSelected() + countPortfoliosSelected() + countListsSelected()
  );
}

function nextIndex(jqueryString) {
  const minId = 0;
  const maxId = 3;
  const theQuery = `[${jqueryString}]`

  const ids = $(theQuery)
    .map(function () {
      return parseInt(this.name.match(/\d/)[0]);
    })
    .get();

  ids.sort((a, b) => a - b);

  for (let x = minId; x <= maxId; x++) {
    if (!ids.includes(x)) {
      return x;
    }
  }
}

export default function () {
  const accountUrl = $("body").attr("data-account-url");
  const reportId = $(".form-section").attr("data-report-id");
  const existingParams = new URLSearchParams(window.location.search);

  // Reloading //
  const reloadPage = function () {

    let reportName = $('#report_name').val();
    let reportYear = $('#report_year').val();
    let reportQuarter = $('#report_quarter').val();
    let reportableType = $('.select-record-type:checked').val();
    let clientId = $('#report_client_id').val();
    let reportableId = $('#report_reportable_id').val();
    let reportTemplateId = $('#reportTemplatesContainer .ethos-radio:checked').val();
    let params = {};
    if (typeof reportName !== 'undefined') {params['name'] = reportName}
    if (typeof reportYear !== 'undefined') {params['year'] = reportYear}
    if (typeof reportQuarter !== 'undefined') {params['quarter'] = reportQuarter}
    if (typeof reportableType !== 'undefined') {params['reportable_type'] = reportableType}
    if (typeof reportableId !== 'undefined') {params['reportable_id'] = reportableId}
    if (typeof clientId !== 'undefined') {params['client_id'] = clientId}
    if (typeof reportTemplateId !== 'undefined') {params['report_template_id'] = reportTemplateId}
    if (existingParams.get('report_scope') == 'report_template'){
      params['report_scope'] = 'report_template';
    }

    // Set scroll and reload
    let baseUrl = window.location.pathname;
    let scrollFilter = $('#reportTemplatesContainer').scrollTop();
    params['sp'] = scrollFilter;

    Turbo.cache.clear();
    Turbo.visit(baseUrl + '?' + $.param(params));
  };

  let checkRequired = function() {
    let isTemplate = $('#report_is_template').val();
    let reportName = $('#report_name').val();
    let reportableId = $('#report_reportable_id').val();
    if (reportName === "") {
      $('.ethosButton.primary-disabled').removeClass('d-none');
      $('.ethosButton.primary').addClass('d-none');

    } else if ((isTemplate !== 'true') && (reportableId === '')) {
      $('.ethosButton.primary-disabled').removeClass('d-none');
      $('.ethosButton.primary').addClass('d-none');

    } else {
      $('.ethosButton.primary-disabled').addClass('d-none');
      $('.ethosButton.primary').removeClass('d-none');

    }    
  }

  // Select record type
  $(".select-record-type").change(function () {

    // Remove reportable id (otherwise tries to find different type with same ID)
    $('#report_reportable_id').val('');

    // Reload page
    reloadPage();

  });

  // Display benchmarks on select
  $("#compareBench").change(function () {
    if ($(this).is(":checked")) {
      $("#chooseBenchmarks").removeClass("d-none");
    } else {
      $("#chooseBenchmarks").addClass("d-none");
    }
  });

  // On remove of a mandatory field by manually typing
  $("#report_name").keyup(function () { 
    checkRequired();
  });

  /********************/
  // Report templates
  /********************/
  $('#report_templates_filter').keyup(function() {
    let val = $(this).val().toLowerCase();
    $('#reportTemplatesContainer .template-option').filter(function() {
      let t = $(this).data('template-name').toLowerCase();
      if (t.indexOf(val) === -1) {
        $(this).removeClass('d-flex').addClass('d-none');
      } else {
        $(this).removeClass('d-none').addClass('d-flex');
      }
    });
  })

  $('#reportTemplatesContainer .ethos-radio').change(function() {
    reloadPage();
  })

  // Scroll templates container on load
  let p = $('#reportTemplatesContainer').data("scroll-p");
  if (typeof p !== "undefined") {
    $('#reportTemplatesContainer').scrollTop(p);
  }


  /********************/
  // Clients
  /********************/

  // Init imported bloodhounds //
  if ($("#clients_search").length > 0) {
    filterTypeahead(
      "#clients_search",
      "clients",
      "/" + accountUrl + "/clients?order_col=first_name",
      475,
      "generic"
    );
  }

  // On selecting a client, filter portfolio typeahead to that client
  $("#clients_search").bind(
    "typeahead:select typeahead:autocomplete",
    function (ev, suggestion) {
      $("#report_client_id").val(suggestion.record_id);
      let filters = {};
      filters['client_id'] = suggestion.record_id;
      $("#featured_portfolio_search").attr("data-filters", filters);

      // Render default Typeahead if displayed
      $('#featured_portfolio_search').typeahead("destroy");
      let el = $('#featured_portfolio_search');
      let api_url = el.attr("data-api-url");
      let params = {};
      params['client_id'] = suggestion.record_id;
      api_url = api_url + '?' + $.param(params);
      let typeahead = new Typeahead(el);
      $.when(typeahead.initializeBloodhound(api_url)).then((bloodhound) =>
        typeahead.render(bloodhound)
      );

    }
  );

  $("#clients_search").blur(function (ev) {
    let val = $(this).val();
    if (val === "") {
      $("#report_client_id").val(val);
      $("#featured_portfolio_search").attr("data-filters", {});

      // Re-set default Typeahead
      $('#featured_portfolio_search').typeahead("destroy");
      let el = $('#featured_portfolio_search');
      let api_url = el.attr("data-api-url");
      api_url = api_url;
      let typeahead = new Typeahead(el);
      $.when(typeahead.initializeBloodhound(api_url)).then((bloodhound) =>
        typeahead.render(bloodhound)
      );

    }
  });

  /********************/
  // Featured Issuer
  /********************/

  if ($("#featured_issuer_search").length > 0) {
    let params = {};
    params["has_score_only"] = "true";
    filterTypeahead(
      "#featured_issuer_search",
      "issuers",
      "/issuers?" + $.param(params),
      42,
      "logo"
    );
  }

  // Check for completion
  $('.default-typeahead').on("typeahead:select", function (event, suggestion) {
    setTimeout(function() {
      checkRequired();      
    }, 300);
  });

  // On clear
  $('.clear-reportable-id-typeahead').click(function() {
    $('.default-typeahead').typeahead('val', '');
    $('#report_reportable_id').val('');
    checkRequired();
  })

  $('.default-typeahead').on("blur", function (event, suggestion) {
    if ($(this).val() === '') {
      $('#report_reportable_id').val('');      
    }
    checkRequired();
  });


}
